import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classnames from 'classnames';
import omit from 'lodash/omit';

// app
import styles from './TableCell.styles';

// mui
import { withStyles, TableCell as MuiTableCell } from '@material-ui/core';

export class TableCell extends PureComponent {
  static propTypes = {
    compact: PropTypes.bool,
    minimal: PropTypes.bool,
    nowrap: PropTypes.bool,
    narrow: PropTypes.bool,
    ellipsis: PropTypes.bool,
    center: PropTypes.bool,
    right: PropTypes.bool,
    bold: PropTypes.bool,
    menu: PropTypes.bool,
    borderless: PropTypes.bool,
    relative: PropTypes.bool,
    className: PropTypes.string,
    nestedClasses: PropTypes.shape({
      root: PropTypes.string,
    }),
    'data-testid': PropTypes.string,
  };

  static defaultProps = {
    nestedClasses: {},
  };

  render() {
    const {
      compact,
      minimal,
      nowrap,
      narrow,
      ellipsis,
      center,
      right,
      bold,
      menu,
      borderless,
      relative,
      children,
      'data-testid': testid,
      className,
      nestedClasses,
      classes,
    } = this.props;

    const classesCell = {
      [classes.compact]: Boolean(compact),
      [classes.minimal]: Boolean(minimal),
      [classes.nowrap]: Boolean(nowrap),
      [classes.narrow]: Boolean(narrow),
      [classes.ellipsis]: Boolean(ellipsis),
      [classes.center]: Boolean(center),
      [classes.right]: Boolean(right),
      [classes.bold]: Boolean(bold),
      [classes.menu]: Boolean(menu),
      [classes.borderless]: Boolean(borderless),
      [classes.relative]: Boolean(relative),
      [className]: Boolean(className),
      [nestedClasses.root]: Boolean(nestedClasses.root),
    };

    const newProps = {
      ...omit(this.props, [
        'compact',
        'minimal',
        'nowrap',
        'narrow',
        'ellipsis',
        'center',
        'right',
        'bold',
        'menu',
        'borderless',
        'relative',
        'children',
        'nestedClasses',
        'classes',
      ]),
    };

    return (
      <MuiTableCell {...newProps} className={classnames(classesCell)} data-testid={testid || 'table-cell'}>
        {children}
      </MuiTableCell>
    );
  }
}

export default compose(withStyles(styles))(TableCell);
